import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import * as API from '../../Endpoints/Endpoints'; // Adjust based on your project structure

const UpdateAllocation = () => {
  const [allocationData, setAllocationData] = useState({
    gamecategory: '',
    gamename: '',
    cardgroup: '',
    cardname: '',
  });

  const [error, setError] = useState(null); // To store any error messages

  const navigate = useNavigate();
  const { cardallocid } = useParams();

  useEffect(() => {
    fetchAllocationData();
  }, [cardallocid]);

  const fetchAllocationData = () => {
    axios({
      url: API.GET_ALLOCATION_BYID(cardallocid), 
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          setAllocationData(res.data[0]); // Assuming the API returns an array
        } else if (res.data) {
          setAllocationData(res.data); // If data is not in an array
        } else {
          setError('No data found');
        }
      })
      .catch((err) => {
        setError('Error fetching allocation data: ' + err.message);
      });
  };
  
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAllocationData({ ...allocationData, [name]: value });
  };

  const updateAllocation = (e) => {
    e.preventDefault();
    axios.put(API.PUT_ALLOCATION_API(cardallocid), allocationData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(() => {
        alert('Allocation updated successfully');
        navigate('/cardalloctable');
      })
      .catch((err) => {
        console.error('Error updating allocation:', err);
        alert('Error updating allocation: ' + err.message);
      });
  };

  const goBack = () => {
    navigate('/cardalloctable');
  };

  return (
    <div className="bg-[#B5B5B5] h-auto pb-20 pt-10">
      <div className="max-w-4xl mx-auto pt-10">
        <form onSubmit={updateAllocation} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          {error && <p className="text-red-500 text-sm mb-4">{error}</p>} {/* Display error message */}

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Game Category</label>
            <input
              type="text"
              name="gamecategory"
              value={allocationData.gamecategory || ''} // Default to empty string if undefined
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Game Name</label>
            <input
              type="text"
              name="gamename"
              value={allocationData.gamename || ''} // Default to empty string if undefined
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Card Group</label>
            <input
              type="text"
              name="cardgroup"
              value={allocationData.cardgroup || ''} // Default to empty string if undefined
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">Card Name</label>
            <input
              type="text"
              name="cardname"
              value={allocationData.cardname || ''} // Default to empty string if undefined
              onChange={handleInputChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <div className="flex items-center justify-between">
            <button
              type="submit"
              className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Update
            </button>
            <button
              type="button"
              onClick={goBack}
              className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Go Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateAllocation;
